<template>
  <div class="htmltext">
      <span>
          {{message}}
      </span>
  </div>
</template>

<script>
export default {
    props:['message']
}
</script>

<style scoped>
    .htmltext{
        color: #fff;
        font-size: 20px;
        margin-top: 31px;
        margin-bottom: 2px;
        line-height: 32px;
        font-weight: 700;
    }
</style>


// WEBPACK FOOTER //
// src/components/common/HtmlText.vue